import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { getSelectedInsurances } from '../../../../Checkout/store/order/selectors';
export const useRefundInsurancePrices = () => {
    const selectedInsurances = useSelector(getSelectedInsurances);
    const insurancePrices = useMemo(() => {
        const insurancePrices = [];
        selectedInsurances.forEach(insurance => {
            if (insurance.policyUrl) {
                insurancePrices.push({
                    name: `${insurance.insuranceProgram.name}*`,
                    price: insurance.insuranceProgram.totalPrice
                });
            }
        });
        return insurancePrices;
    }, [selectedInsurances]);
    return insurancePrices;
};
